import React from "react";
import styled from "styled-components";

export const inputWithPrefix = (Component) => (props) => {
  return (
    <Container>
      <PrefixStyle>{props.prefix}</PrefixStyle>
      <Component {...props} />
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  display: flex;
  justify-items: start;
  align-items: center;
  width: 100%;
`;
const PrefixStyle = styled.span`
  position: relative;
  display: flex;
  padding-right: 5px;
  z-index: 10;
  font-size: small;
  white-space: nowrap;
  height: 100%;
  background-color: #fff;
`;
